import type React from "react"
import { Mail, Phone, MapPin} from "lucide-react"

const Footer: React.FC = () => {
  return (
    <footer className="relative bg-gradient-to-br from-slate-950 via-slate-900 to-black text-white pt-20 mt-10 pb-8 before:content-[''] before:absolute before:-top-12 before:left-0 before:right-0 before:h-12 before:bg-gradient-to-br before:from-slate-950 before:via-slate-900 before:to-black before:rounded-t-[100%] before:shadow-2xl">
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div 
          className="absolute top-0 left-1/4 w-96 h-96 bg-red-600/10 rounded-full blur-3xl" 
          style={{ minWidth: '384px', minHeight: '384px' }}
        />
        <div 
          className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl"
          style={{ minWidth: '384px', minHeight: '384px' }}
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Brand Section */}
          <div className="flex flex-col items-center ">
            <div className="flex items-center gap-2 mb-4">
              <span className="text-2xl font-900 text-gradient">Hegra</span>
              <span className="text-2xl font-900 text-primary">Vision</span>
            </div>
            <p className="text-gray-400 leading-relaxed text-sm">
              Empowering the next generation of tech professionals through innovative, hands-on education.
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center">
            <h4 className="font-bold text-white mb-4 text-lg">Navigation</h4>
            <ul className="space-y-2">
              {["Home", "Courses", "About Us"].map((link) => (
                <li key={link}>
                  <a
                    href={`/${link.toLowerCase().replace(" ", "-")}`}
                    className="text-gray-400 hover:text-white transition-colors duration-300 text-sm"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col items-center">
            <h4 className="font-bold text-white mb-4 text-lg">Contact</h4>
            <div className="flex flex-col items-center  space-y-3 text-sm ">
              <div className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors">
                <Mail className="w-4 h-4" />
                <span>info@hegravision.com</span>
              </div>
              <div className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors">
                <Phone className="w-4 h-4" />
                <span>077 124 123 9</span>
              </div>
              <div className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors">
                <MapPin className="w-4 h-4" />
                <span>53/1A Shalawa Rd,  Nugegoda</span>
              </div>
            </div>
          </div>

          {/* Social Links */}
          {/* <div className="flex flex-col items-center">
            <h4 className="font-bold text-white mb-4 text-lg">Follow Us</h4>
            <div className="flex justify-center gap-4">
              {[
                { icon: Facebook, label: "facebook", color: "blue", url: "https://facebook.com" },
                { icon: Linkedin, label: "LinkedIn", color: "blue", url: "https://linkedin.com" },
              ].map(({ icon: Icon, label, color, url }) => (
                <a
                  key={label}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className={`p-3 rounded-lg bg-white/10 hover:bg-gradient-to-r hover:from-${color}-600 hover:to-${color}-700 transition-all duration-300`}
                >
                  <Icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div> */}
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 mb-8" />

        {/* Bottom Footer */}
        <div className="flex flex-col sm:flex-row justify-between items-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Hegra Vision. All rights reserved.</p>
          <p className="mt-4 sm:mt-0">Built with passion by the Hegra Innovations</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
